import { func, object, bool } from 'prop-types';
import { withProps } from 'recompose';
import Dropdown from 'components/base/Dropdown/Dropdown';
import periods, { periodPropType } from 'maps/period-types';

function createProps(props) {
  const {
    customPeriods = null,
    additionalPeriods,
    periodTypes,
    withoutDefault = false,
    isRoundedDropdown,
  } = props;

  const customTypePeriods = Object.assign(customPeriods ? customPeriods : {});

  const allPeriods = Object.assign(
    {},
    customTypePeriods,
    additionalPeriods || {},
    !withoutDefault ? periods : {}
  );

  return {
    items: Object.values(periodTypes || allPeriods),
    gtag: 'period-dropdown',
    isRoundedDropdown,
  };
}

const PeriodDropdown = withProps(createProps)(Dropdown);

PeriodDropdown.propTypes = {
  selectedItem: periodPropType.isRequired,
  onChange: func.isRequired,
  onSelect: func,
  customPeriods: object,
  withoutDefault: bool,
};

export default PeriodDropdown;
